// src/API/friendService.js
import axiosInstance from "./axiosInstance";

export const friendService = {
  // Get all alumni (excluding current user and existing connections)
  getAllAlumni: async (search = "", pageNumber = 1, pageSize = 20) => {
    try {
      const response = await axiosInstance.get(
        `/Friend/alumni?search=${encodeURIComponent(search)}&pageNumber=${pageNumber}&pageSize=${pageSize}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching alumni:", error);
      throw error;
    }
  },

  // Send a friend request
  sendFriendRequest: async (receiverId) => {
    try {
      const response = await axiosInstance.post("/Friend/send-request", {
        ReceiverId: receiverId,
      });
      return response.data;
    } catch (error) {
      console.error("Error sending friend request:", error);
      throw error;
    }
  },

  // Accept a friend request
  acceptFriendRequest: async (requestId) => {
    try {
      const response = await axiosInstance.post(`/Friend/accept-request/${requestId}`);
      return response.data;
    } catch (error) {
      console.error("Error accepting friend request:", error);
      throw error;
    }
  },

  // Reject a friend request
  rejectFriendRequest: async (requestId) => {
    try {
      const response = await axiosInstance.post(`/Friend/reject-request/${requestId}`);
      return response.data;
    } catch (error) {
      console.error("Error rejecting friend request:", error);
      throw error;
    }
  },

  // Cancel a sent friend request
  cancelFriendRequest: async (requestId) => {
    try {
      const response = await axiosInstance.delete(`/Friend/cancel-request/${requestId}`);
      return response.data;
    } catch (error) {
      console.error("Error cancelling friend request:", error);
      throw error;
    }
  },

  // Get pending friend requests (received)
  getPendingRequests: async (pageNumber = 1, pageSize = 50) => {
    try {
      const response = await axiosInstance.get(
        `/Friend/pending-requests?pageNumber=${pageNumber}&pageSize=${pageSize}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching pending requests:", error);
      throw error;
    }
  },

  // Get sent friend requests
  getSentRequests: async (pageNumber = 1, pageSize = 50) => {
    try {
      const response = await axiosInstance.get(
        `/Friend/sent-requests?pageNumber=${pageNumber}&pageSize=${pageSize}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching sent requests:", error);
      throw error;
    }
  },

  // Get friends list
  getFriends: async (pageNumber = 1, pageSize = 50) => {
    try {
      const response = await axiosInstance.get(
        `/Friend/friends?pageNumber=${pageNumber}&pageSize=${pageSize}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching friends:", error);
      throw error;
    }
  },

  // Check friend status with another user
  checkFriends: async (otherStudentId) => {
    try {
      const response = await axiosInstance.get(`/Friend/check-friends/${otherStudentId}`);
      return response.data;
    } catch (error) {
      console.error("Error checking friend status:", error);
      throw error;
    }
  },

  // Remove/unfriend a friend
  removeFriend: async (friendId) => {
    try {
      const response = await axiosInstance.delete(`/Friend/remove-friend/${friendId}`);
      return response.data;
    } catch (error) {
      console.error("Error removing friend:", error);
      throw error;
    }
  },
};

export default friendService;

